export const GET_LIST_CUSTOMER = "GET_LIST_CUSTOMER";
export const GET_LIST_CUSTOMER_SUCCESS = "GET_LIST_CUSTOMER_SUCCESS";
export const GET_LIST_CUSTOMER_FAILURE = "GET_LIST_CUSTOMER_FAILURE";

export const GET_DETAIL_CUSTOMER = "GET_DETAIL_CUSTOMER";
export const GET_DETAIL_CUSTOMER_SUCCESS = "GET_DETAIL_CUSTOMER_SUCCESS";
export const GET_DETAIL_CUSTOMER_FAILURE = "GET_DETAIL_CUSTOMER_FAILURE";

export const LICH_SU_GIAO_DICH_CUSTOMER = "LICH_SU_GIAO_DICH_CUSTOMER";
export const LICH_SU_GIAO_DICH_CUSTOMER_SUCCESS =
  "LICH_SU_GIAO_DICH_CUSTOMER_SUCCESS";
export const LICH_SU_GIAO_DICH_CUSTOMER_FAILURE =
  "LICH_SU_GIAO_DICH_CUSTOMER_FAILURE";

export const GET_AUTOCOMPLETE_CUSTOMER = "GET_AUTOCOMPLETE_CUSTOMER";
export const GET_AUTOCOMPLETE_CUSTOMER_SUCCESS =
  "GET_AUTOCOMPLETE_CUSTOMER_SUCCESS";
export const GET_AUTOCOMPLETE_CUSTOMER_FAILURE =
  "GET_AUTOCOMPLETE_CUSTOMER_FAILURE";
